import { PageWrapper, Title, SuperTitle, Section, CollapseSubsection, Subsection, Paragraph, MDParagraph, FancyLink, EmailLink } from "./components";
import { useParams, Link } from "react-router-dom";

import directoryData from "./directory_data";

const categoryById = (categoryId) => {
    const found = directoryData.categories.filter((category) => category.id === categoryId);

    if (found.length > 0) {
        return found[0];
    } else {
        return null
    }
}

const CompanyHeader = ({ company }) => {
    return <>
        <div>
            <Link
                to={ company.website }
                target='_blank'
                rel='noopener noreferrer'
            >{ company.website }</Link>
        </div>
    </>
}

export const Category = () => {
    const { categoryId } = useParams();
    const category = categoryById(categoryId);

    return <PageWrapper>
        <Link to='/directory/'>
            <SuperTitle>Biopharma Software Directory</SuperTitle>
        </Link>
        <Title>{ category.display }</Title>
        <MDParagraph>{ category.longDescription }</MDParagraph>
        {
            category.children.map((child) => <Section title={ child.display }>
            <Paragraph>{ child.descr }</Paragraph>
            {
                directoryData.companies
                .filter((c) => c.categories.includes(child.id))
                .map((c) => <CollapseSubsection title={ c.display }  image={`/static/logos/${c.icon}`} key={ c.id }>
                    <CompanyHeader company={ c } />
                    <MDParagraph>{ c.description }</MDParagraph>

                </CollapseSubsection>)
            }
            </Section>)
        }
        <Paragraph>
            If you notice any companies missing from this page, send an email to <EmailLink />
        </Paragraph>
        <FancyLink to='/directory/' direction='left'>
            Back the Biopharma Software Directory
        </FancyLink>
    </PageWrapper>
}

const Directory = () => {
    return <PageWrapper>
        <Section title='Biopharma Software Directory'>
            <Paragraph>
                This is a manually curated list of software tools that I think may be useful for biopharma teams. It's basically a second incarnation of the Biopharma AI Landscape, an earlier resource with LLM-generated summaries of more than 300 companies.
            </Paragraph>
            <Paragraph>
                With the Landscape, I found that the AI summaries often weren't worth the time it took to read, so for this version I'm taking my time, working slowly and deliberately, category by category, to write concise descriptions and create subcategories that make the differences clearer.
            </Paragraph>
            <Paragraph>
                If the companies or categories you're interested in aren't on the list yet, check back later and I might have added it. Or you can send me an email (<EmailLink />) and let me know. If I get enough interest in a particular category, I'll bump it up my list.
            </Paragraph>
            { directoryData.categories.map((category) =>
                <Subsection title={ category.display } to={`/directory/${category.id}/`} key={ category.id }>
                    { category.descr }
                </Subsection>
            )}
            <Paragraph>
                More categories coming soon...
            </Paragraph>
        </Section>
        <FancyLink to='/' direction='left'>
            Back to Merelogic Home
        </FancyLink>
    </PageWrapper>
}

export default Directory;
